import { useParams } from '@thd-olt-component-react/router';

export function usePreviewByID() {
  const { id: idFromQueryParams } = useParams();
  if (idFromQueryParams) return idFromQueryParams;
  return null;
}
